export const allowedLocales = {
  'en-GB': true,
  'sv-SE': true,
}

export type Locale = keyof typeof allowedLocales

export const defaultLocale: Locale = 'sv-SE'
